import React from 'react';
import {
  Box,
  Container,
  Grid,
  makeStyles,
  withStyles,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Question from '../question/Question';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';

const UpperLowerCard = ({ daten, cardcontent, handleUpdate, url, timex }) => {
  let cardID =
    daten['chain'].length > 0
      ? daten['chain'][daten['chain'].length - 1].toString()
      : daten['chain'][0].toString();
  let step = daten['chain'].length;
  let timer;
  const loadupperlower = () => {
    let telefonInfos = {
      timex,
    };

    axios
      .post('https://iw.server-novis.com/' + 'getupperlower', {
        daten: JSON.stringify(telefonInfos),
      })
      .catch(function (error) {
        //ausgabe
      })
      .then(response => {
        if (
          response?.data.phupper != undefined &&
          response?.data.phlower != undefined
        ) {
          daten['info'][cardID]['phupper'] = response.data.phupper;
          daten['info'][cardID]['phmiddle'] = response.data.phmiddle;
          daten['info'][cardID]['phlower'] = response.data.phlower;
          clearInterval(timer);
          handleUpdate(daten);
        } else {
          //handleUpdate(daten);
          console.log(response);
        }
      });
  };

  if (daten['info'][cardID]?.phupper === undefined) {
    console.log(daten['info'][cardID]?.phupper);
    timer = setInterval(loadupperlower, 1000);
  }

  let renderObjekt = (
    <div className="w-2/5 flex flex-col items-center">
      <Spinner
        animation="border"
        role="status"
        style={{ width: '10rem', height: '10rem' }}
      >
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      <div className="mt-25px">
        Ihre Informationen werden gerade bearbeitet.<br></br> Sie werden
        automatisch weitergeleitet.
      </div>
    </div>
  );

  return (
    <div
      className="h-full flex flex-col justify-center items-center"
      id="upperlower"
    >
      {renderObjekt}
    </div>
  );
};

export default UpperLowerCard;
